// extracted by mini-css-extract-plugin
export default {"pop_up":"styles_pop_up__kehk0","block":"styles_block__B6lnl","block_small":"styles_block_small__b-DbF"};